import React from 'react';

import { GridEventListener, GridRowParams } from '@mui/x-data-grid';

import { reverse } from 'named-urls';

import Grid from 'components/Grid';

import { ColumnDefinition } from 'components/Grid/types';

import { useStore } from 'utils/hooks/store';

import routes from 'core/routes';

import EntityActionCell from 'components/Entities/EntityActionCell';
import { entityCreatedColumn } from 'components/Entities/EntityCreatedColumn';

import { EntityModules, ProtectorType } from 'core/constants';

import { RisksTableProps } from './types';

export const basicRisksColumns = [
  {
    field: 'risks__name',
    headerName: 'Name',
    protectorType: ProtectorType.ShortText,
  },
  {
    field: 'risks__id',
    headerName: 'ID',
    protectorType: ProtectorType.Number,
  },
  {
    field: 'risks__owner',
    headerName: 'Owner',
    protectorType: ProtectorType.User,
  },
  {
    field: 'risks__status',
    headerName: 'Status',
    protectorType: ProtectorType.SingleChoice,
  },
  {
    field: 'risks__initialRisk',
    headerName: 'Inherent risk',
    protectorType: ProtectorType.RiskFactor,
  },
  {
    field: 'risks__residualRisk',
    headerName: 'Residual risk',
    protectorType: ProtectorType.RiskFactor,
  },
  {
    field: 'risks__targetRisk',
    headerName: 'Target risk',
    protectorType: ProtectorType.RiskFactor,
    defaultVisibility: false,
  },
  {
    field: 'risks__nextReviewDate',
    headerName: 'Next review date',
    protectorType: ProtectorType.Date,
  },
  entityCreatedColumn(EntityModules.Risks),
] as unknown as ColumnDefinition[];

const RisksTable: React.FunctionComponent<RisksTableProps> = ({ onError, onRefreshCallback }): React.ReactElement => {
  const { routing, riskDetails } = useStore();

  const onRowClick: GridEventListener<'rowClick'> = (item: GridRowParams): void => {
    routing.push(reverse(routes.dashboard.risks.details, { entityId: item.id }));
  };

  return (
    <Grid
      basicColumns={
        [
          ...basicRisksColumns,
          {
            field: 'actions',
            type: 'actions',
            headerName: '',
            maxWidth: 50,
            ariaLabel: 'actions_cell',
            renderCell: ({ row, colDef }: { row: { uuid: string }; colDef: ColumnDefinition }) => (
              <EntityActionCell rowData={row} actions={colDef.actions} store={riskDetails} />
            ),
            filterOperators: null,
            sortable: false,
          },
        ] as unknown as ColumnDefinition[]
      }
      entity="risks"
      onError={onError}
      dataURL="/api/entities/risks/"
      fieldsURL="/api/entities/risks/fields/"
      customNoRowsText="No risks have been created yet"
      onRowClick={onRowClick}
      onRefreshCallback={onRefreshCallback}
      disableSelectAllColumns
      onlyBasicExport={false}
    />
  );
};

export default RisksTable;
